module.exports = {
      id: "share-facebook-usage",
      viewBox: "0 0 42 42",
      url: __webpack_public_path__ + "svg-sprite-39dbc991ee8a2ec1b35aeef6495011e2.svg#share-facebook",
      toString: function () {
        return this.url;
      }
    }